import { render, staticRenderFns } from "./ObjectPredict.vue?vue&type=template&id=925f086a&lang=html&"
import script from "./ObjectPredict.vue?vue&type=script&lang=js&"
export * from "./ObjectPredict.vue?vue&type=script&lang=js&"
import style0 from "./ObjectPredict.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports